// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Intercom = require("../../reason/common/Intercom.bs.js");
var MarkupHelpers = require("../../reason/common/MarkupHelpers/MarkupHelpers.bs.js");
var TailwindMerge = require("tailwind-merge");
var JsxRuntime = require("react/jsx-runtime");

function Footer(props) {
  var currentYear = new Date().getFullYear();
  var match = Intercom.useIntercom();
  var show = match.show;
  var links = [
    [
      "About",
      "https://www.topagentnetwork.com/about",
      undefined
    ],
    [
      "Contact",
      "https://www.topagentnetwork.com/contact",
      (function (evt) {
          evt.preventDefault();
          show();
        })
    ],
    [
      "Privacy",
      "https://www.topagentnetwork.com/privacy-policy",
      undefined
    ],
    [
      "Terms of Service",
      "https://www.topagentnetwork.com/terms-of-service",
      undefined
    ],
    [
      "Usage Rules",
      "https://www.topagentnetwork.com/usage-rules",
      undefined
    ]
  ];
  return JsxRuntime.jsx("footer", {
              children: JsxRuntime.jsx(MarkupHelpers.Container.make, {
                    children: JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("div", {
                                  children: "© " + currentYear.toString() + " Top Agent Network"
                                }),
                            JsxRuntime.jsx("div", {
                                  children: links.map(function (param) {
                                        var onClick = param[2];
                                        var title = param[0];
                                        return JsxRuntime.jsx("div", {
                                                    children: JsxRuntime.jsx("a", {
                                                          children: title,
                                                          className: "text-zinc-500 transition duration-150 hover:underline",
                                                          href: param[1],
                                                          onClick: (function (evt) {
                                                              if (onClick !== undefined) {
                                                                return onClick(evt);
                                                              }
                                                              
                                                            })
                                                        }),
                                                    className: "whitespace-nowrap"
                                                  }, title);
                                      }),
                                  className: TailwindMerge.twMerge([
                                        "flex flex-col items-center gap-y-4 text-base",
                                        "sm:flex-row sm:gap-y-0 sm:gap-x-8 sm:justify-around",
                                        "md:justify-center md:items-center",
                                        "lg:justify-start lg:items-start"
                                      ])
                                })
                          ],
                          className: TailwindMerge.twMerge([
                                "grid grid-cols-1 md:grid-rows-2 gap-y-6 md:gap-y-2.5",
                                "md:grid-cols-[auto_auto] md:grid-rows-1 md:gap-y-0 md:gap-x-2.5 md:justify-between"
                              ])
                        })
                  }),
              className: "py-6 bg-white text-center"
            });
}

var make = Footer;

exports.make = make;
/* Intercom Not a pure module */
